import type { QueryClient } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import { Cart, useLocalStorage, UserLocale } from 'hooks/userPreferences';
import type { RemoveCartItemsMutation } from 'services/shopify';
import { ShopifyService } from 'services/shopify';
import { mapShopifyCart } from 'utils/mappers/mapShopifyCart';

import { CART_KEY } from './useCart';

export async function removeItem(
  lineItemId: string,
  setCartId: (cartId: { id: string }) => void,
  getCartId: () => { id?: string } | null,
): Promise<NonNullable<RemoveCartItemsMutation['cartLinesRemove']>['cart']> {
  const { id: cartId } = getCartId() || {};

  if (cartId) {
    const response = await ShopifyService.removeCartItems({
      cartId,
      lineIds: [lineItemId],
    });

    if (response?.cartLinesRemove?.cart?.id) {
      setCartId({ id: response.cartLinesRemove.cart.id });
    }

    return response.cartLinesRemove?.cart;
  }
}

export const useRemoveItem = (queryClient: QueryClient) => {
  const {
    value: { countryCode },
  } = useLocalStorage(UserLocale);
  const { getValue, setStoredValue: setCartId } = useLocalStorage(Cart);

  return useMutation({
    mutationFn: (lineItemId: string) =>
      removeItem(lineItemId, setCartId, getValue),
    onSuccess: (cart) => {
      if (cart) {
        queryClient.setQueriesData(
          { queryKey: [CART_KEY, countryCode] },
          mapShopifyCart(cart),
        );
      }
    },
  });
};
